import { ClerkProvider } from "@clerk/react";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import { defaultAuthDestination } from "./auth/destination";
import { App } from "./App";
import { ClerkSessionProvider, MissingSessionProvider } from "./auth/session";
import { clerkLocalization } from "./auth/clerkAppearance";
import { registerInstallationWorker } from "./pwa/registerInstallationWorker";
import "@fontsource/inter/latin-400.css";
import "@fontsource/inter/latin-500.css";
import "@fontsource/inter/latin-600.css";
import "@fontsource/inter/latin-700.css";
import "./styles/index.css";

const publishableKey = import.meta.env.VITE_CLERK_PUBLISHABLE_KEY;
const root = document.getElementById("root");
if (!root) throw new Error("SignalBill root element is missing");

createRoot(root).render(
  <StrictMode>
    {publishableKey ? (
      <ClerkProvider publishableKey={publishableKey} signInUrl="/login" signUpUrl="/signup"
        signInFallbackRedirectUrl={defaultAuthDestination} signUpFallbackRedirectUrl={defaultAuthDestination} localization={clerkLocalization}>
        <ClerkSessionProvider>
          <App />
        </ClerkSessionProvider>
      </ClerkProvider>
    ) : (
      <MissingSessionProvider>
        <App />
      </MissingSessionProvider>
    )}
  </StrictMode>,
);

// Installation support never gates Clerk, routing, or draft persistence.
registerInstallationWorker();
